import {createAemClient} from '@uwm/aem';

export default createAemClient({
    graphqlEndpoint: 'dcxconnex-loyalty',
    damPath: 'dcxconnex/loyalty',
    localAssetsHost: 'https://loyalty.icpwa-dev.aws.pmicloud.biz',
});
